module.exports = __webpack_public_path__ + "files/3671d2b561fe848dbf454d9f368c5185.svg";